import Model from '@/app/Model'

export class Modification extends Model {
	static fields () {
		return {
			id: null,
			name: null,
			fullTitle: null,
			type: null,
			startDate: null,
			endDate: null,
			bodyType: null,
			driveType: null,
			fuelType: null,
			gearType: null,
			power: null,
			numOfCyl: null,
			numOfValves: null,
			capacity: null,
			platformType: null,
			axleConfiguration: null,
			suspensionTypes: null,
			kbas: null
		}
	}
	static hasMany () {
		return {
			//
		}
	}
}

export function createModification (data) {
	return Object.freeze(new Modification(data))
}
